export default {
  title: 'Vitrină',
  fields: {
    has_reservations: {
      label: 'Afișați rezervările pe vitrină',
    },
  },
  button: {
    save: 'Salvați',
    preview: 'Previzualizare',
  },
  no_storefront: {
    title: 'Nicio vitrină găsită',
    description: 'Vă rugăm să creați o vitrină.',
    button: {
      storefront: 'Mergeți la vitrină',
    },
  },
  response_messages: {
    success: 'Actualizat cu succes.',
    failed: 'Actualizare eșuată.',
  },
};
